import styled from "styled-components";

export const CardContainer = styled.div`
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    height: 500px;
    width: 300px;
    border-radius: 1rem;
    padding: 1rem;
    background: ${({ theme }) => theme.newBg2};
    &:hover {
        box-shadow: ${({ theme }) => theme.boxShadow};
        transform: translateY(-0.5rem);
        transition: all 0.3s ease-in-out;
    }
`

export const CardImage = styled.div`
    width: 260px;
    height: 240px;
    border-radius: 1rem;
    //margin: 20px;
    background: ${({ theme }) => theme.newBg3};
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    box-shadow: ${({ theme }) => theme.boxShadow};

    > img {
        //width: 100%;
        //height: 100%;
        max-height: 100%;
        max-width: 100%;
    }

    
    .crypto-seal-bg {
        width: 100%;
    }

    .crypto-seal-character {
        position: absolute;
        width: 50%;
    }

    .crypto-dappers-image {
        width: 200px;
        image-rendering: -webkit-crisp-edges;
        image-rendering: pixelated;
        image-rendering: crisp-edges;
    }

    .pixelated-image {
        width: 200px;
        image-rendering: -webkit-crisp-edges;
        image-rendering: pixelated;
        image-rendering: crisp-edges;
    }

    .crypto-companions-image {
        width: 200px;
        image-rendering: -webkit-crisp-edges;
        image-rendering: pixelated;
        image-rendering: crisp-edges;
    }
    
`
export const CardTitle = styled.div`
    font-size: 1.2rem;
    font-weight: bold;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin: 1rem 0;
    width: 100%;
`

export const CardCollection = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 0.8rem;
    font-style: italic;
    margin: 0.5rem 0;

    svg {
        margin-right: 0.3rem;
        fill: rgb(32, 129, 226);
    }
`

export const CardText = styled.span`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: calc(100% - 40px);
    cursor: pointer;
`

export const CardMeta = styled.div`
    width: 100%;
    display: flex;
    flex-direction:row;
    justify-content: flex-end space-between;
    align-items: center;
`

export const CardPrice = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    span {
        font-size: 0.6rem;
        font-style: italic;
    }
    > div {
        display:flex;
        flex-direction: row;
        align-items: center;
        font-size: 0.8rem;
        font-weight: bold;
    }
`

export const CardCreator = styled.div`
    flex:2;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 1rem 0;
    cursor: pointer;
`

export const CreatorImage = styled.div`
    width: 40px;
    height: 40px;
    border-radius: 1rem;
    margin-right: 0.5rem;
    background: ${({ theme }) => theme.newBg3};
`
export const CreatorInfo = styled.div`
    display: flex;
    flex-direction: column;
`

export const CreatorLabel = styled.div`
    font-size: 0.6rem;
    font-style: italic;
    margin-bottom: 0.3rem;
`

export const CreatorName = styled.div`
    font-size: 0.8rem;
    font-weight: 500;
`

export const CardButtons = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    align-self: flex-end;
    padding: 0.5rem;
    position: relative;
    bottom: 0;
`

export const CardButton = styled.div`
    flex:1;
    margin: 0 10px;
    cursor: pointer;
    text-decoration: none;
    //color: ${({ theme }) => theme.text3};
    font-size: 1rem;
    padding: 1rem;
    border-radius: 1.5rem;
    border: 2px solid ${({ theme }) => theme.bg3};
    text-align: center;
    &:hover {
        box-shadow: ${({ theme }) => theme.boxShadow};
        transform: scale(1.01);
    }
`

export const CardLikeCount = styled.div`
    height: 32px;
    min-width: 64px;
    max-width: 80px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    font-size: 0.6rem;
    font-weight: bold;
    background: ${({ theme }) => theme.newBg2};
    border-radius: 0.5rem;
    position: absolute;
    top: 5px;
    right: 0px;
    z-index: 1;

    > svg {
        margin-right: 5px;
        &:only-child {
            margin-right: 0;
        }
    }

    &.liked,
    &:hover {
        cursor: pointer;
        > svg {
            color: ${({ theme }) => theme.red2};
            font-size: 0.8rem;
        }
    }
`;